module.exports = __webpack_public_path__ + "static/media/bad.24569767.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/slider/slides/bad.jpeg
// module id = 351
// module chunks = 0